import { formatCount, formatNumber } from "@memorang/helpers/common";
import type { TagsByType } from "types/tag";

const getSectionTags = (
	numItems: number,
	tagsByType: TagsByType,
	handleShowPurchaseDialog: () => void,
	hasAccess?: boolean,
) => {
	const allTags = Object.keys(tagsByType).flatMap((key) => tagsByType[key]);

	const lockedTags = allTags.filter((item) =>
		hasAccess ? !item.locked : item.locked,
	);

	const unlockedTags = allTags.filter(({ locked }) => !locked);

	const numUnlockedTagsTopics = unlockedTags.length;
	const numLockedTagsTopics = lockedTags.length;

	const uniqueItemIds = new Set<string | number>();
	for (const tag of unlockedTags) {
		if (tag.items) {
			for (const item of tag.items) {
				uniqueItemIds.add(item.id);
			}
		}
	}
	const numUnlockedItems = uniqueItemIds.size;

	const lockedSectionItemsCount = hasAccess
		? numItems
		: numItems - numUnlockedItems;

	const sections = hasAccess
		? [
				{
					title: `${numUnlockedTagsTopics} ${formatCount(
						"topic",
						numUnlockedTagsTopics,
					)} • ${formatNumber(numItems)} items`,
					cta: null,
					tags: unlockedTags,
					action: null,
					mode: "flat" as const,
				},
			]
		: [
				{
					title: `${numUnlockedTagsTopics} ${formatCount(
						"topic",
						numUnlockedTagsTopics,
					)} • ${formatNumber(numItems - lockedSectionItemsCount)} items`,
					cta: lockedTags.length ? "Free" : undefined,
					icon: "gift-outline",
					tags: unlockedTags,
					mode: "outlined" as const,
					action: handleShowPurchaseDialog,
				},
				...(lockedTags?.length
					? [
							{
								title: `${numLockedTagsTopics} ${formatCount(
									"topic",
									lockedSectionItemsCount,
								)} • ${formatNumber(lockedSectionItemsCount)} items`,
								cta: "Upgrade",
								icon: "crown-outline",
								mode: "flat" as const,
								tags: lockedTags,
								action: handleShowPurchaseDialog,
							},
						]
					: []),
			];

	return [...sections];
};

export { getSectionTags };
